//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

//CALENDER
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMMINGEVENT = "/upcommingevents";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

//Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";

//project list
export const GET_PROJECT_LIST = "/project/list";

//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_SELLERS = "/sellers";
export const DELETE_PRODUCT = "/delete/product";

//Task
export const GET_TASK_LIST = "/task-list";
export const ADD_NEW_TASK = "/add/task";
export const UPDATE_TASK = "/update/task";
export const DELETE_TASK = "/delete/task";

//Crypto
export const GET_TRANSATION_LIST = "/transation-list";
export const GET_ORDRER_LIST = "/order-list";

//TicketsList
export const GET_TICKETS_LIST = "/tickets-list";
export const ADD_NEW_TICKET = "/add/ticket";
export const UPDATE_TICKET = "/update/ticket";
export const DELETE_TICKET = "/delete/ticket";

// Conatct
export const GET_CONTACTS = "/crmcontacts";
export const ADD_NEW_CONTACT = "/add/contact";
export const UPDATE_CONTACT = "/update/contact";
export const DELETE_CONTACT = "/delete/contact";

// Crm
export const GET_DEALS = "/deals";

// Lead
export const GET_LEADS = "/leads";
export const ADD_NEW_LEAD = "/add/lead";
export const UPDATE_LEAD = "/update/lead";
export const DELETE_LEAD = "/delete/lead";

// Companies
export const GET_COMPANIES = "/companies";
export const ADD_NEW_COMPANIES = "/add/companies";
export const UPDATE_COMPANIES = "/update/companies";
export const DELETE_COMPANIES = "/delete/companies";


//Invoice
export const GET_INVOICES = "/invoices";
export const ADD_NEW_INVOICE = "/add/invoice";
export const UPDATE_INVOICE = "/update/invoice";
export const DELETE_INVOICE = "/delete/invoice";

//Mailbox
export const GET_MAIL_DETAILS = "/mail";
export const DELETE_MAIL = "/delete/mail";

// ORDERS
export const GET_ORDERS = "/orders";
export const ADD_NEW_ORDER = "/add/order";
export const UPDATE_ORDER = "/update/order";
export const DELETE_ORDER = "/delete/order";

// CUSTOMERS
export const GET_CUSTOMERS = "/customers";
export const ADD_NEW_CUSTOMER = "/add/customer";
export const UPDATE_CUSTOMER = "/update/customer";
export const DELETE_CUSTOMER = "/delete/customer";



